import {
    configureDialogViewportScroll,
    whenCbarDialogReady,
    type CbarDialogElement,
} from './cbar-dialog-helpers';
import {runOnce} from './run-once';

export const DOCUMENT_PREVIEW_DIALOG_SELECTOR =
    '.document-preview-dialog, .receipt-dialog, .email-preview-dialog, .invoice-cache-html-dialog, .invoice-preview-dialog';

export const DOCUMENT_PREVIEW_CONTENT_CLASS = 'document-preview-dialog__content';
export const DOCUMENT_HTML_PREVIEW_CLASS = 'document-html-preview';

const PREFERRED_SCALE = 0.92;
const MIN_SCALE = 0.85;

export function wrapDocumentHtmlPreview(html: string): string {
    return `<div class="${DOCUMENT_HTML_PREVIEW_CLASS} receipt-dialog__preview">${html}</div>`;
}

export function fitDocumentPreviewInDialog(dialog: CbarDialogElement): void {
    const scroller = dialog.shadowRoot?.querySelector('.scroller');
    if (!(scroller instanceof HTMLElement)) {
        return;
    }

    const preview = dialog.querySelector<HTMLElement>(`.${DOCUMENT_HTML_PREVIEW_CLASS}, .receipt-dialog__preview`);
    if (!preview) {
        return;
    }

    preview.style.zoom = '';

    const availableWidth = scroller.clientWidth - 24;
    const naturalWidth = preview.scrollWidth;
    if (availableWidth <= 0 || naturalWidth <= 0) {
        preview.style.zoom = String(PREFERRED_SCALE);
        return;
    }

    let scale = PREFERRED_SCALE;
    if (naturalWidth * scale > availableWidth) {
        scale = Math.max(MIN_SCALE, availableWidth / naturalWidth);
    }

    preview.style.zoom = String(scale);
}

export function bindDocumentPreviewFit(dialog: CbarDialogElement): void {
    if (dialog.dataset.documentPreviewFitBound === 'true') {
        return;
    }

    dialog.dataset.documentPreviewFitBound = 'true';
    configureDialogViewportScroll(dialog);

    dialog.addEventListener('opened', () => {
        requestAnimationFrame(() => {
            fitDocumentPreviewInDialog(dialog);
        });
    });
}

export function configureDocumentPreviewDialogs(root: ParentNode = document): void {
    root.querySelectorAll<CbarDialogElement>(DOCUMENT_PREVIEW_DIALOG_SELECTOR).forEach((dialog) => {
        bindDocumentPreviewFit(dialog);
    });
}

export function initDocumentPreviewDialogs(): void {
    runOnce('document-preview-dialogs', () => {
        void whenCbarDialogReady().then(() => {
            configureDocumentPreviewDialogs();
        });
    });
}
